export const tr = {
    'banners-limit-in-campaign': 'Bu kampanyaya maksimum {limit} reklam eklenebilir.',
    error: 'Hata oluştu',
    'no-campaign-found': 'Kampanyalar bulunamadı',
    'search-by-campaign': 'Kampanyalara göre arama '
};
